export default __webpack_public_path__ + "assets/5751be16adddd5386833d6823c604b07.svg";